import React, { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";
import { setMuted, setSubtitlesOn } from "@store/avatarSlice";
import { Drawer, Fab, IconButton, Stack } from "@mui/material";
import MuteButton from "@components/MuteButton/MuteButton";
import CallEndOutlinedIcon from "@mui/icons-material/CallEndOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import SideBar from "@components/SideBar/SideBar";
import { useTranslation } from "react-i18next";
import Timer from "@components/Timer";
import SubtitlesButton from "@components/SubtitlesButton";

const CompanionToolbar: FC<{
  vertical?: boolean;
  onStop: () => void;
  stopping: boolean;
  startTime: Date | null;
}> = ({ vertical = true, onStop, stopping, startTime }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { muted, subtitlesOn } = useSelector(
    (state: RootState) => state.avatar,
  );
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleMenuClick = () => {
    setDrawerOpen((open) => !open);
  };

  const toggleMute = () => {
    dispatch(setMuted(!muted));
  };

  const toggleSubtitles = () => {
    dispatch(setSubtitlesOn(!subtitlesOn));
  };

  return (
    <>
      <Stack
        justifyContent="space-between"
        flexDirection={vertical ? "column" : "row"}
        width={vertical ? "auto" : "100%"}
        height={vertical ? "100%" : "auto"}
        alignItems="center"
        padding={vertical ? "10px 10px 20px" : "8px 16px"}
        boxSizing="border-box"
        gap="16px"
      >
        <IconButton
          size="medium"
          aria-label={t("header.openDrawerButton")}
          onClick={handleMenuClick}
          sx={{ color: "#fff" }}
        >
          {!drawerOpen ? (
            <MenuIcon fontSize="medium" />
          ) : (
            <MenuOpenIcon fontSize="medium" />
          )}
        </IconButton>

        <Stack
          flex="1"
          alignItems="center"
          flexDirection={vertical ? "column" : "row"}
          justifyContent="space-between"
        >
          <Stack gap="16px" flexDirection={vertical ? "column" : "row"}>
            <MuteButton muted={muted} onClick={toggleMute} />

            <SubtitlesButton on={subtitlesOn} onClick={toggleSubtitles} />
          </Stack>

          <Stack
            gap="16px"
            alignItems="center"
            flexDirection={vertical ? "column" : "row"}
          >
            <Timer startTime={startTime} variant="light" />
            <Fab
              id="stopcall-button"
              onClick={onStop}
              color="error"
              size="small"
              disabled={stopping}
            >
              <CallEndOutlinedIcon />
            </Fab>
          </Stack>
        </Stack>
      </Stack>

      <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <SideBar onNavigate={() => setDrawerOpen(false)} />
      </Drawer>
    </>
  );
};

export default CompanionToolbar;
